import { createContext, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const BookingContext = createContext({ openBooking: () => {} });
export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const navigate = useNavigate();

  const openBooking = useCallback(() => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "book_now_open", { event_category: "engagement" });
    }
    navigate("/book");
  }, [navigate]);

  return (
    <BookingContext.Provider value={{ openBooking }}>
      {children}
    </BookingContext.Provider>
  );
};
